// src/pages/Creditors.jsx
import { useEffect, useState, useCallback, useRef } from "react";
import Autosuggest from 'react-autosuggest';
import { Plus, Trash2, ChevronDown, ChevronUp, ArrowDownAZ, CalendarDays, DollarSign, Home, Gavel, CreditCard, Sigma } from "lucide-react";
import { primaryDebtor, secondaryFilingDebtor } from '../../utils/debtors';
const zipcodes = require('zipcodes');
function debounce(fn, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn(...args), wait);
    };
  }
export default function Creditors({}) {
  const [creditors, setCreditors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [caseLoading, setCaseLoading] = useState(true);
  const token = localStorage.getItem("clientToken");
  const caseId = localStorage.getItem("clientCaseId");
  const [deletingIds, setDeletingIds] = useState([]);
  const [sortOption, setSortOption] = useState("name");
  const [showLinkAssetModal, setShowLinkAssetModal] = useState(false);
  const [selectedCreditor, setSelectedCreditor] = useState(null);
  const [selectedAssetId, setSelectedAssetId] = useState("");
  const [sortAsc, setSortAsc] = useState(true);
  const [caseData, setCaseData] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [linking, setLinking] = useState(false);
  const [updatingType, setUpdatingType] = useState(false);
  const [showAddVehicleForm, setShowAddVehicleForm] = useState(false);
  const [showAddPropertyForm, setShowAddPropertyForm] = useState(false);
  const [declineReason, setDeclineReason] = useState("");
  const [saving, setSaving] = useState(false);
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const [nameSuggestions, setNameSuggestions] = useState([]);
  const cache = useRef({});
  const fetchSuggestions = useCallback(
    debounce(async ({ value }) => {
      if (value.length < 3) {
        setNameSuggestions([]);
        return;
      }
      if (cache.current[value]) {
        return setNameSuggestions(cache.current[value]);
      }
      const token = localStorage.getItem("clientToken");
      const resp = await fetch(
        `${process.env.REACT_APP_API_URL}/common-creditors/?q=${encodeURIComponent(value)}`,
        { headers: { Authorization:`Bearer ${token}` } }
      );
      if (resp.ok) {
        setNameSuggestions(await resp.json());
      }
    }, 600),
    []
  );

    const onSuggestionsFetchRequested = ({ value }) => {
        fetchSuggestions({ value });
    };

    const onSuggestionsClearRequested = () => {
        setNameSuggestions([]);
    };

    // when the user types in the input:
    const onNameChange = (event, { newValue }) => {
        setNewCreditor({ ...newCreditor, account_name: newValue });
    };

    // when they pick one suggestion:
    const onSuggestionSelected = (event, { suggestion }) => {
        setNewCreditor({
        ...newCreditor,
        account_name: suggestion.account_name,
        street:        suggestion.street1,
        street2:        suggestion.street2,
        city:          suggestion.city,
        state:         suggestion.state,
        zip_code:      suggestion.zip_code,
        account_type:  suggestion.account_type,
        });
    };

    const getSuggestionValue = s => s.account_name;
    const renderSuggestion   = s => <div>{s.account_name}</div>;

  const [newCreditor, setNewCreditor] = useState({
    account_name: "",
    balance: "",
    street: "",
    street2: "",
    zip_code: "",
    debt_type: "",
    account_type: "",
    date_opened: "",
    account_number: "",
    who_owes: ""
  });
  const [newVehicle, setNewVehicle] = useState({
    year: "",
    make: "",
    model: "",
    mileage:"",
    ownership: "debtor1"
  });
  
  const [newProperty, setNewProperty] = useState({
    street1: "",
    city: "",
    state: "",
    zip_code: "",
    ownership: "debtor1"
  });

  useEffect(() => {
    if (showAddModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  
    // Clean up on component unmount just in case
    return () => {
      document.body.style.overflow = '';
    };
  }, [showAddModal]);
  useEffect(() => {
    const fetchCase = async () => {
      try {
        const token = localStorage.getItem("clientToken");// or pass it via props
        const res = await fetch(`${process.env.REACT_APP_API_URL}/case/${caseId}/creditors/case-details/`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await res.json();
        setCaseData({
            ...data,
            real_estates: data.real_estates || [],
            vehicles: data.vehicles || []
          });
      } catch (err) {
        console.error("Error fetching case:", err);
      } finally {
        setCaseLoading(false);
      }
    };
  
    fetchCase();
  }, []);

  const fetchCreditors = async () => {
    console.log("Using BACKEND_URL:", BACKEND_URL);
    const res = await fetch(`${process.env.REACT_APP_API_URL}/case/${caseId}/creditors/`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (res.ok) {
      const data = await res.json();
      setCreditors(data);
    } else {
      console.error("Failed to fetch creditors");
    }
  };
  
  // Then useEffect just calls it
  useEffect(() => {
    fetchCreditors();
  }, []);
  useEffect(() => {
    const fetchCreditors = async () => {
    
      const res = await fetch(`${process.env.REACT_APP_API_URL}/case/${caseId}/creditors/`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.ok) {
        const data = await res.json();
        setCreditors(data);
      } else {
        console.error("Failed to fetch creditors");
      }
      setLoading(false);
    };

    fetchCreditors();

  }, [caseId, token]);
  const debtor1 = primaryDebtor(caseData?.debtors, { filingOnly: true });
  const debtor2 = secondaryFilingDebtor(caseData?.debtors);
  const debtor1Name = debtor1?.first_name || "Debtor 1";
  const debtor2Name = debtor2?.first_name || "Spouse";
  
  useEffect(() => {

    const needsLinking = creditors.find(c =>
      ["mortgage", "auto"].includes((c.account_type || "").toLowerCase()) &&
      (!c.asset_links || c.asset_links.length === 0)
    );
    if (needsLinking) {
      setSelectedCreditor(needsLinking);
      //setShowLinkAssetModal(true);
    }
  }, [creditors]);

  const validateAddressFields = async (addressObj) => {
    let { street, street2, zip, city, state } = addressObj;
    let address1 = street;
    let address2 = street2;

    // Fallback if city or state is missing
    if (!city || !state) {
      const result = zipcodes.lookup(zip);
      if (result) {
        city = result.city;
        state = result.state;
      } else {
        city = "dafasdfasdfaf";
        state = "IL";
      }
    }

    try {
      const response = await fetch(`${BACKEND_URL}/validate-address-intake`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ address1, address2, zip, city, state }),
      });

      if (!response.ok) {
        throw new Error(await response.text());
      }

      const validated = await response.json();
      console.log(validated);

      // If we have a match, return the standardized address object
      if (validated.matches && validated.matches.length > 0 && validated.address) {
        return validated.address;
      } else {
        alert('Error: USPS could not verify your address.');
        return false;
      }
    } catch (error) {
      console.error('Address validation error:', error);
      setSaving(false);
      alert('Address validation failed: ' + error.message);
      return false;
    }
  };
  
  const getWhoOwesLabel = (code) => {
    if (!debtor1) return code;
  
    switch (code) {
      case "debtor1":
        return debtor1.first_name;
      case "debtor2":
        return debtor2 ? debtor2.first_name : "Spouse";
      case "joint":
        return debtor2 ? `${debtor1.first_name} and ${debtor2.first_name}` : debtor1.first_name;
      case "debtor1_third":
        return `${debtor1.first_name} and a third party`;
      case "debtor2_third":
        return debtor2 ? `${debtor2.first_name} and a third party` : "Spouse and a third party";
      case "authorized":
        return "Authorized User";
      default:
        return code;
    }
  };
    const debtSummary = creditors.reduce(
        (acc, c) => {
        // Ensure type is one of the known categories; default to "unsecured" otherwise
        const validTypes = ["secured", "priority", "unsecured", 'executory'];
        const type = validTypes.includes(c.debt_type) ? c.debt_type : "unsecured";
        acc[type].count += 1;
        acc[type].amount += Number(c.balance || 0);
        acc.total.count += 1;
        acc.total.amount += Number(c.balance || 0);
        return acc;
        },
        {
        secured: { count: 0, amount: 0 },
        priority: { count: 0, amount: 0 },
        unsecured: { count: 0, amount: 0 },
        executory: { count: 0, amount: 0 },
        total: { count: 0, amount: 0 },
        }
    );
    const handleChangeAccountType = async (reasonCode) => {
        setUpdatingType(true);
      
        if (!selectedCreditor) return;
      
        try {
          if (reasonCode === "paid") {
            // Delete creditor instead of updating
            await fetch(`${process.env.REACT_APP_API_URL}/case/${caseId}/creditors/${selectedCreditor.id}/delete/`, {
              method: "DELETE",
              headers: {
                Authorization: `Bearer ${token}`,
              },
            });
          } else {
            // Downgrade account type
            const downgradeMap = {
              deficiency: "deficiency",
              mistake: "unsecured",
            };
      
            const newType = downgradeMap[reasonCode] || "unsecured";
      
            await fetch(`${process.env.REACT_APP_API_URL}/case/${caseId}/creditors/link/`, {
              method: "POST",
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                action: "update_type",
                creditor_id: selectedCreditor.id,
                account_type: newType,
              }),
            });
          }
      
          setShowLinkAssetModal(false);
          setSelectedCreditor(null);
          setSelectedAssetId("");
          setDeclineReason("");
          fetchCreditors();
        } catch (err) {
          alert("Failed to update or remove creditor.");
        } finally {
          setUpdatingType(false);
        }
      };
    const handleAddCreditor = async (e) => {
        e.preventDefault();
        setSaving(true);

        const check_full_address = {
          street: newCreditor.street,
          street2: newCreditor.street2,
          zip: newCreditor.zip_code,
        };

        const validatedAddr = await validateAddressFields(check_full_address);
        let updatedCreditor = {};
        if (validatedAddr) {
          console.log("validated and adding validaded address")
          const addr = validatedAddr;
          updatedCreditor = {
            ...newCreditor,
            street: addr.streetAddressAbbreviation || newCreditor.street,
            street2: addr.secondaryAddress,
            city: addr.city || newCreditor.city,
            state: addr.state || newCreditor.state,
            zip_code: addr.ZIPCode || newCreditor.zip_code,
            full_address: `${addr.streetAddressAbbreviation}${addr.secondaryAddress ? ', ' + addr.secondaryAddress : newCreditor.street2}, ${addr.city}, ${addr.state} ${addr.ZIPCode}`,
          };
        } else {
          updatedCreditor = {
            ...newCreditor,
            street: newCreditor.street,
            street2: newCreditor.street2,
            city: newCreditor.city,
            state: newCreditor.state,
            zip_code: newCreditor.zip_code,
            full_address: `${newCreditor.street}${newCreditor.street2 ? ', ' + newCreditor.street2 : ''}, ${newCreditor.city}, ${newCreditor.state} ${newCreditor.zip_code}`,
          };
        }
        const token = localStorage.getItem("clientToken");

        const res = await fetch(`${process.env.REACT_APP_API_URL}/case/${caseId}/add-creditor/`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatedCreditor),
        });

        if (res.ok) {
          const newData = await res.json();
          setCreditors((prev) => [...prev, newData]);
          setShowAddModal(false);
          fetchCreditors();
        } else {
          alert("Failed to add creditor.");
        }

        setSaving(false);
      };

      const handleLinkAsset = async () => {
        if (!selectedCreditor || !selectedAssetId) return;
      
        const asset_type = selectedCreditor.account_type.toLowerCase() === "mortgage" ? "realproperty" : "vehicle";
      
        setLinking(true);
        
        try {
          const res = await fetch(`${process.env.REACT_APP_API_URL}/case/${caseId}/creditors/link/`, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              action: "link",
              creditor_id: selectedCreditor.id,
              asset_type: asset_type,
              object_id: selectedAssetId,
            }),
          });
      
          if (res.ok) {
            // Success: close modal, clear state, refresh if needed
            setShowLinkAssetModal(false);
            setSelectedCreditor(null);
            setSelectedAssetId("");
      
          } else {
            const data = await res.json();
            alert("Failed to link asset: " + data.error);
          }
        } catch (err) {
          console.error("Error linking asset:", err);
          alert("An error occurred.");
        } finally {
            setLinking(false);
            fetchCreditors();
        }
      };
    const deleteCreditor = async (creditorId) => {
        
        const confirm = window.confirm("Are you sure you want to delete this creditor?");
        
        if (!confirm) return;
        setDeletingIds(prev => [...prev, creditorId]);
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/case/${caseId}/creditors/${creditorId}/delete/`, {
            method: "DELETE",
            headers: {
                Authorization: `Bearer ${token}`,
            },
            });

            if (res.ok) {
            setCreditors((prev) => prev.filter((c) => c.id !== creditorId));
            } else {
            alert("Failed to delete creditor.");
            }
        } catch (err) {
            console.error(err);
            alert("An error occurred.");
        } finally {
        setDeletingIds(prev => prev.filter(x => x !== creditorId));
        }
    };

    const sortedCreditors = [...creditors].sort((a, b) => {
        let result = 0;
      
        if (sortOption === "name") {
          const nameA = a?.account_name || "";
          const nameB = b?.account_name || "";
          result = nameA.localeCompare(nameB);
        } else if (sortOption === "date") {
          const dateA = a?.date_opened ? new Date(a.date_opened) : new Date(0);
          const dateB = b?.date_opened ? new Date(b.date_opened) : new Date(0);
          result = dateA - dateB;
        } else if (sortOption === "balance") {
          const balanceA = Number(a?.balance || 0);
          const balanceB = Number(b?.balance || 0);
          result = balanceA - balanceB;
        }
      
        return sortAsc ? result : -result;
      });

  if (loading) return <div className="flex flex-col items-center justify-center h-[40vh] text-center text-gray-700 space-y-4">
  <div className="h-8 w-8 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin"></div>
  <div>
    <p className="text-lg font-medium">Loading creditors…</p>
    <p className="text-sm text-gray-500 mt-1">Please refresh if they do not appear after 30 seconds.</p>
  </div>
</div>;
  if (!caseData) return <div>Case not found</div>;
  return (
    <div className="mx-auto w-full px-2 sm:px-4 md:px-6 lg:px-8">
      <h1 className="text-2xl font-bold text-indigo-700 mb-4">Your Creditors</h1>
      
        <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-4 text-sm text-gray-700 shadow-sm">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 text-center">
            <div>
            <Home className="mx-auto h-5 w-5 text-indigo-600 mb-1" />
            <p className="font-semibold text-gray-900">Secured</p>
            <p>{debtSummary.secured.count} account(s)</p>
            <p>${debtSummary.secured.amount.toLocaleString()}</p>
            </div>
            <div>
            <Gavel className="mx-auto h-5 w-5 text-red-500 mb-1" />
            <p className="font-semibold text-gray-900">Priority</p>
            <p>{debtSummary.priority.count} account(s)</p>
            <p>${debtSummary.priority.amount.toLocaleString()}</p>
            </div>
            <div>
            <CreditCard className="mx-auto h-5 w-5 text-green-600 mb-1" />
            <p className="font-semibold text-gray-900">Unsecured</p>
            <p>{debtSummary.unsecured.count} account(s)</p>
            <p>${debtSummary.unsecured.amount.toLocaleString()}</p>
            </div>
            <div>
            <Sigma className="mx-auto h-5 w-5 text-gray-600 mb-1" />
            <p className="font-semibold text-gray-900">Total</p>
            <p>{debtSummary.total.count} account(s)</p>
            <p>${debtSummary.total.amount.toLocaleString()}</p>
            </div>
        </div>
        </div>
        <div className="flex justify-center my-6">
  <button
    onClick={() => setShowAddModal(true)}
    className="bg-indigo-600 text-white px-6 py-2 rounded-lg shadow hover:bg-indigo-700 transition"
  >
    <Plus className="w-4 h-4 inline-block mr-2" />
    Add Creditor
  </button>
</div>
{showAddModal && (
  <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center p-4">
    <div className="bg-white w-full max-w-xl max-h-[90vh] sm:max-h-[85vh] overflow-y-auto p-4 sm:p-6 rounded-xl shadow-xl border border-gray-200">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold text-gray-800">Add New Creditor</h2>
        <button onClick={() => setShowAddModal(false)} className="text-gray-500 hover:text-gray-800">
          &times;
        </button>
      </div>
      <form onSubmit={handleAddCreditor} className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-3 text-sm">
            <div>
              <label className="block font-medium text-gray-700 mb-1">
                Creditor Name
              </label>
              <div className="relative">
                <Autosuggest
                    suggestions={nameSuggestions}
                    onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                    onSuggestionsClearRequested={onSuggestionsClearRequested}
                    getSuggestionValue={getSuggestionValue}
                    onSuggestionSelected={onSuggestionSelected}
                    inputProps={{
                    placeholder: 'Creditor Name',
                    value: newCreditor.account_name,
                    onChange: onNameChange,
                    className: 'w-full border rounded px-3 py-1.5'
                    }}
                    renderSuggestion={s => (
                    <li className="px-4 py-2 hover:bg-indigo-50 cursor-pointer">
                        <strong>{s.account_name}</strong>
                        <div className="text-xs text-gray-500">{s.city}, {s.state}</div>
                    </li>
                    )}
                    renderSuggestionsContainer={({ containerProps, children }) => (
                    <ul
                        {...containerProps}
                        className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto"
                    >
                        {children}
                    </ul>
                    )}
                    theme={{
                    suggestionsList: '',
                    suggestion: '',
                    // we’re doing all styling in renderSuggestionsContainer/renderSuggestion
                    }}
                />
                </div>
            </div>

            <div>
                <label className="block font-medium text-gray-700 mb-1">Balance</label>
                <input type="number" className="w-full border rounded px-3 py-1.5" value={newCreditor.balance} onChange={(e) => setNewCreditor({...newCreditor, balance: e.target.value})} required />
            </div>

            <div>
                <label className="block font-medium text-gray-700 mb-1">Street Address</label>
                <input type="text" className="w-full border rounded px-3 py-1.5" value={newCreditor.street} onChange={(e) => setNewCreditor({...newCreditor, street: e.target.value})} required />
            </div>
            

            <div>
                <label className="block font-medium text-gray-700 mb-1">Zip Code</label>
                <input type="text" inputMode="numeric" className="w-full border rounded px-3 py-1.5" value={newCreditor.zip_code} onChange={(e) => setNewCreditor({...newCreditor, zip_code: e.target.value})} required />
            </div>

            <div>
                <label className="block font-medium text-gray-700 mb-1">Debt Type</label>
                <select className="w-full border rounded px-3 py-1.5" value={newCreditor.debt_type} onChange={(e) => setNewCreditor({...newCreditor, debt_type: e.target.value})} required>
                <option value="">Select</option>
                <option value="secured">Secured</option>
                <option value="priority">Priority</option>
                <option value="unsecured">Unsecured</option>
                <option value="executory">Executory Contract</option>
                </select>
            </div>

            {newCreditor.debt_type && (
                <div>
                <label className="block font-medium text-gray-700 mb-1">Account Type</label>
                <select className="w-full border rounded px-3 py-1.5" value={newCreditor.account_type} onChange={(e) => setNewCreditor({...newCreditor, account_type: e.target.value})}>
                    <option value="">Select</option>
                    {newCreditor.debt_type === "secured" && <>
                    <option value="mortgage">Mortgage</option>
                    <option value="auto">Auto</option>
                    <option value="judgment lien">Judgment Lien</option>
                    <option value="statutory lien">Statutory Lien</option>
                    </>}
                    {newCreditor.debt_type === "priority" && <>
                    <option value="tax">Tax</option>
                    <option value="child support">Child Support</option>
                    </>}
                    {newCreditor.debt_type === "unsecured" && <>
                    <option value="medical">Medical</option>
                    <option value="charge account">Charge Account</option>
                    <option value="credit card">Credit Card</option>
                    <option value="personal loan">Personal Loan</option>
                    <option value="student loan">Student Loan</option>
                    <option value="collection">Collection</option>
                    <option value="notice purposes">Notice Purposes</option>
                    <option value="unsecured">Unsecured</option>
                    </>}
                </select>
                </div>
            )}

            <div>
                <label className="block font-medium text-gray-700 mb-1">Who Owes</label>
                <select
                value={newCreditor.who_owes}
                onChange={(e) => setNewCreditor({ ...newCreditor, who_owes: e.target.value })}
                className="w-full border border-gray-300 rounded px-3 py-1.5"
                required
                >
                <option value="">Select</option>
                <option value="debtor1">{debtor1Name}</option>
                {debtor2 && <option value="debtor2">{debtor2Name}</option>}
                {debtor2 && <option value="joint">{debtor1Name} and {debtor2Name}</option>}
                <option value="debtor1_third">{debtor1Name} and a third party</option>
                {debtor2 && <option value="debtor2_third">{debtor2Name} and a third party</option>}
                <option value="authorized">Authorized User</option>
                </select>
            </div>

            <div>
                <label className="block font-medium text-gray-700 mb-1">Date Opened <span className="text-gray-500 text-sm">(optional)</span></label>
                <input type="date" className="w-full border rounded px-3 py-1.5" value={newCreditor.date_opened} onChange={(e) => setNewCreditor({...newCreditor, date_opened: e.target.value})} />
            </div>

            <div>
                <label className="block font-medium text-gray-700 mb-1">Account Number <span className="text-gray-500 text-sm">(optional)</span></label>
                <input type="text" className="w-full border rounded px-3 py-1.5" value={newCreditor.account_number} onChange={(e) => setNewCreditor({...newCreditor, account_number: e.target.value})} />
            </div>

            <div className="col-span-1 sm:col-span-2 flex justify-end gap-4 mt-2">
                <button type="button" onClick={() => setShowAddModal(false)} className="text-gray-600 hover:underline">Cancel</button>
                <button
                    type="submit"
                    disabled={saving}
                    className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700 disabled:opacity-50 flex items-center justify-center gap-2"
                    >
                    {saving && (
                        <span className="inline-block h-4 w-4 border-2 border-t-transparent border-white rounded-full animate-spin"></span>
                    )}
                    {saving ? "Saving..." : "Save Creditor"}
                    </button>
            </div>
            </form>
    </div>
  </div>
)}
      {creditors.length === 0 ? (
        <div className="flex flex-col items-center justify-center h-[40vh] text-center text-gray-700 space-y-4">
        <div>
          <p className="text-lg font-medium">Could not load creditors</p>
          <p className="text-sm text-gray-500 mt-1">Please refresh your browser.</p>
        </div>
      </div>
      ) : (
        <div>
            <div className="flex flex-wrap items-center justify-between mb-6 gap-4">
            <div className="flex items-center gap-2">
                <span className="text-sm font-medium text-gray-700">Sort by:</span>
                <div className="relative">
                <select
                    value={sortOption}
                    onChange={(e) => setSortOption(e.target.value)}
                    className="appearance-none bg-white border border-gray-300 text-sm rounded-md pl-3 pr-8 py-1.5 shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                >
                    <option value="name">Name</option>
                    <option value="date">Date Opened</option>
                    <option value="balance">Balance</option>
                </select>
                <div className="absolute right-2 top-2.5 text-gray-400 pointer-events-none">
                    <ChevronDown className="w-4 h-4" />
                </div>
                </div>
                <button
                onClick={() => setSortAsc(!sortAsc)}
                className="p-1.5 rounded-md border border-gray-300 bg-white hover:bg-indigo-50 transition-all"
                title="Toggle sort direction"
                >
                {sortAsc ? (
                    <ChevronUp className="w-4 h-4 text-indigo-600" />
                ) : (
                    <ChevronDown className="w-4 h-4 text-indigo-600" />
                )}
                </button>
            </div>
            </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {sortedCreditors.map((c) => (
            <div
            key={c.id}
            className={`relative p-4 rounded-lg shadow border transition-opacity ${
                deletingIds.includes(c.id) ? 'opacity-50 pointer-events-none' : 'bg-white'
              }`}
            >
                {/* Spinner overlay while deleting */}
                {deletingIds.includes(c.id) && (
                    <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-70 z-10">
                    <svg
                        className="animate-spin h-6 w-6 text-red-600"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                    >
                        <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                        />
                        <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v8H4z"
                        />
                    </svg>
                    </div>
                )}
          {false &&( <button
                onClick={() => deleteCreditor(c.id)}
                className="absolute top-2 right-2 text-red-500 hover:text-red-700"
                title="Delete"
            >
                <Trash2 size={18} />
            </button>
        )}
            <h2 className="text-md font-semibold mb-1">{c.account_name}</h2>
            <p className="text-sm text-gray-600">Type: {c.account_type}</p>
            {c.asset_links && c.asset_links.length > 0 && (
            <p className="text-sm text-gray-600">
                Collateral: {
                c.asset_links.map(link => {
                    const isVehicle = link.asset_type === "vehicle";
                    const asset = isVehicle
                    ? caseData.vehicles.find(v => String(v.id) === String(link.object_id))
                    : caseData.real_estates.find(p => String(p.id) === String(link.object_id));

                    if (!asset) return "Unknown";

                    return isVehicle
                    ? `${asset.year} ${asset.make} ${asset.model}`
                    : `${asset.street1}, ${asset.city}`;
                }).join(", ")
                }
            </p>
            )}
            <p className="text-sm text-gray-600">Who Owes: {getWhoOwesLabel(c.who_owes)}</p>
            <p className="text-sm text-gray-600">Balance: ${c.balance}</p>
            <p className="text-sm text-gray-600">Opened: {c.date_opened}</p>
            <p className="text-sm text-gray-600">Address: {c.street1} {c.city} {c.state} {c.zip_code}</p>
            </div>
        ))}
        {showLinkAssetModal && selectedCreditor && (
  <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
    <div className="bg-white rounded-xl p-6 w-full max-w-md shadow-xl border border-gray-200">
      <h2 className="text-lg font-bold mb-4 text-gray-800">
        Link Asset to Creditor: <span className="text-indigo-600">{selectedCreditor.account_name}</span>
      </h2>
      {selectedCreditor.account_type.toLowerCase() === "auto" && (
        <>
          <p className="text-sm text-gray-700 mb-2">
            A creditor account was indicated as an <strong>auto loan</strong>. Please link it to the correct vehicle.
          </p>
          <p className="text-sm text-gray-400 mt-1">
        <strong>Balance:</strong> ${Number(selectedCreditor.balance).toLocaleString()}
        </p>
        <p className="text-sm text-gray-400 mt-1">
        <strong>Date Opened:</strong> {new Date(selectedCreditor.date_opened).toLocaleDateString()}
        </p>
          <label className="block text-sm font-medium mb-1">Select Vehicle</label>
          <select
            value={selectedAssetId}
            onChange={(e) => setSelectedAssetId(e.target.value)}
            className="w-full border rounded px-3 py-2 mb-2"
          >
            <option value="">-- Select a vehicle --</option>
            {caseData.vehicles.map((v) => (
              <option key={v.id} value={v.id}>
                {v.year} {v.make} {v.model}
              </option>
            ))}
          </select>

          <div className="flex items-center justify-between text-sm mb-4">
            <span className="text-gray-600">Vehicle not listed?</span>
            <button
              onClick={() => setShowAddVehicleForm(true)}
              className="text-indigo-600 font-medium hover:underline"
            >
              Add Vehicle
            </button>
          </div>
          {showAddVehicleForm && (
            <div className="space-y-2 mb-4 bg-gray-50 p-3 rounded border">
                <input
                type="text"
                placeholder="Year"
                required
                className="w-full border px-2 py-1 rounded"
                value={newVehicle.year}
                onChange={(e) => setNewVehicle({ ...newVehicle, year: e.target.value })}
                inputMode="numeric"
                />
                <input
                type="text"
                placeholder="Make"
                required
                className="w-full border px-2 py-1 rounded"
                value={newVehicle.make}
                onChange={(e) => setNewVehicle({ ...newVehicle, make: e.target.value })}
                />
                <input
                type="text"
                placeholder="Model"
                required
                className="w-full border px-2 py-1 rounded"
                value={newVehicle.model}
                onChange={(e) => setNewVehicle({ ...newVehicle, model: e.target.value })}
                />
                <input
                type="text"
                placeholder="Approx. Mileage"
                required
                className="w-full border px-2 py-1 rounded"
                value={newVehicle.mileage}
                onChange={(e) => setNewVehicle({ ...newVehicle, mileage: e.target.value })}
                inputMode="numeric"
                />
                <label className="block text-sm font-medium">Who owns this vehicle?</label>
                <select
                value={newVehicle.ownership}
                onChange={(e) => setNewVehicle({ ...newVehicle, ownership: e.target.value })}
                className="w-full border rounded px-2 py-1 mb-2"
                >
                <option value="debtor1">{debtor1Name}</option>
                {debtor2 && <option value="debtor2">{debtor2Name}</option>}
                {debtor2 && <option value="d1_d2">{debtor1Name} and {debtor2Name}</option>}
                <option value="joint_third">{debtor1Name} and a third party</option>
                </select>
                <button
                className="bg-indigo-600 text-white px-3 py-1 rounded hover:bg-indigo-700"
                onClick={async () => {
                    if (!newVehicle.make.trim() || !newVehicle.model.trim()) {
                        alert("Make and model are required.");
                        return;
                      }
                    const mileageNum = parseInt(newVehicle.mileage, 10);
                    if (isNaN(mileageNum) || mileageNum < 0) {
                    alert("Mileage must be a positive number.");
                    return;
                    }
                    const yearNum = parseInt(newVehicle.year, 10);
                    const nextYear = new Date().getFullYear() + 1;

                    if (isNaN(yearNum) || yearNum < 1930 || yearNum > nextYear) {
                    alert(`Enter a valid year.`);
                    return;
                    }
                    const res = await fetch(`${process.env.REACT_APP_API_URL}/case/${caseId}/add-vehicle/`, {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(newVehicle),
                    });
                    if (res.ok) {
                    const newV = await res.json();
                    setCaseData(prev => ({ ...prev, vehicles: [...prev.vehicles, newV] }));
                    setSelectedAssetId(newV.id);
                    setShowAddVehicleForm(false);
                    } else {
                    alert("Failed to add vehicle.");
                    }
                }}
                >
                Save Vehicle
                </button>
            </div>
            )}
          <div className="mt-4">
            <label className="block text-sm font-medium mb-1">
                If this account is not secured, select why:
            </label>
            <select
                value={declineReason}
                onChange={(e) => setDeclineReason(e.target.value)}
                className="w-full border rounded px-3 py-2"
            >
                <option value="">-- Choose a reason --</option>
                <option value="paid">Paid in full</option>
                <option value="deficiency">Deficiency after repo/foreclosure</option>
                <option value="mistake">Mistakenly listed as secured</option>
            </select>

            {declineReason && (
                <button
                    disabled={!declineReason || updatingType}
                    onClick={() => handleChangeAccountType(declineReason)}
                    className="mt-3 w-full bg-yellow-500 text-white font-medium py-2 rounded hover:bg-yellow-600 transition flex items-center justify-center gap-2 disabled:opacity-50"
                    >
                    {updatingType && <span className="inline-block h-4 w-4 border-2 border-t-transparent border-white rounded-full animate-spin" />}
                    Update Account
                    </button>
            )}
            </div>
        </>
      )}

      {selectedCreditor.account_type.toLowerCase() === "mortgage" && (
        <>
          <p className="text-sm text-gray-700 mb-2">
            A creditor account was indicated as a <strong>mortgage</strong>. Please link it to the correct property.
          </p>
          <p className="text-sm text-gray-400 mt-1">
        <strong>Balance:</strong> ${Number(selectedCreditor.balance).toLocaleString()}
        </p>
        <p className="text-sm text-gray-400 mt-1">
        <strong>Date Opened:</strong> {new Date(selectedCreditor.date_opened).toLocaleDateString()}
        </p>
          <label className="block text-sm font-medium mb-1">Select Property</label>
          <select
            value={selectedAssetId}
            onChange={(e) => setSelectedAssetId(e.target.value)}
            className="w-full border rounded px-3 py-2 mb-2"
          >
            <option value="">-- Select a property --</option>
            {caseData.real_estates.map((prop) => (
              <option key={prop.id} value={prop.id}>
                {prop.street1}
              </option>
            ))}
          </select>

          <div className="flex items-center justify-between text-sm mb-4">
            <span className="text-gray-600">Property not listed?</span>
            <button
              onClick={() => setShowAddPropertyForm(true)}
              className="text-indigo-600 font-medium hover:underline"
            >
              Add Property
            </button>
          </div>
          {showAddPropertyForm && (
            <div className="space-y-2 mb-4 bg-gray-50 p-3 rounded border">
                <input
                type="text"
                placeholder="Street"
                className="w-full border px-2 py-1 rounded"
                value={newProperty.street1}
                onChange={(e) => setNewProperty({ ...newProperty, street1: e.target.value })}
                />
                <input
                type="text"
                placeholder="City"
                className="w-full border px-2 py-1 rounded"
                value={newProperty.city}
                onChange={(e) => setNewProperty({ ...newProperty, city: e.target.value })}
                />
                <input
                type="text"
                placeholder="State"
                className="w-full border px-2 py-1 rounded"
                value={newProperty.state}
                onChange={(e) => setNewProperty({ ...newProperty, state: e.target.value })}
                />
                <input
                type="text"
                placeholder="Zip"
                className="w-full border px-2 py-1 rounded"
                value={newProperty.zip_code}
                onChange={(e) => setNewProperty({ ...newProperty, zip_code: e.target.value })}
                inputMode="numeric"
                />
                <label className="block text-sm font-medium">Who owns this property?</label>
                <select
                value={newProperty.ownership}
                onChange={(e) => setNewProperty({ ...newProperty, ownership: e.target.value })}
                className="w-full border rounded px-2 py-1 mb-2"
                >
                <option value="debtor1">{debtor1Name}</option>
                {debtor2 && <option value="debtor2">{debtor2Name}</option>}
                {debtor2 && <option value="d1_d2">{debtor1Name} and {debtor2Name}</option>}
                <option value="joint_third">{debtor1Name} and a third party</option>
                </select>
                <button
                className="bg-indigo-600 text-white px-3 py-1 rounded hover:bg-indigo-700"
                onClick={async () => {
                    const check_full_address = {
                      street: newProperty.street1,
                      street2: newProperty.street2||"",
                      zip: newProperty.zip_code,
                      city: newProperty.city,
                      state: newProperty.state,
                    };
                  
                    const validated = await validateAddressFields(check_full_address);
                    let updatedProperty = {}
                    if (!validated) {
                      updatedProperty = {
                        ...newProperty,
                        street1: newProperty.street1,
                        city: newProperty.city,
                        state: newProperty.state,
                        zip_code: newProperty.zip_code,
                      };
                    }
                    else
                    {
                      const addr = validated;

                      updatedProperty = {
                        ...newProperty,
                        street1: addr.streetAddressAbbreviation || newProperty.street1,
                        city: addr.city || newProperty.city,
                        state: addr.state  || newProperty.state,
                        zip_code: addr.ZIPCode || newProperty.zip_code,
                      };
                    }
                    
                  
                    const res = await fetch(`${process.env.REACT_APP_API_URL}/case/${caseId}/add-property/`, {
                      method: "POST",
                      headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify(updatedProperty),
                    });
                  
                    if (res.ok) {
                      const newP = await res.json();
                      setCaseData(prev => ({ ...prev, real_estates: [...prev.real_estates, newP] }));
                      setSelectedAssetId(newP.id);
                      setShowAddPropertyForm(false);
                    } else {
                      alert("Failed to add property.");
                    }
                  }}
                >
                Save Property
                </button>
            </div>
            )}

          <label className="block text-sm font-medium mb-1">Not a secured debt?</label>
          <select
            value={declineReason}
            onChange={(e) => setDeclineReason(e.target.value)}
            className="w-full border rounded px-3 py-2 mb-4"
          >
            <option value="">-- Select reason --</option>
            <option value="paid">Paid in full</option>
            <option value="deficiency">Deficiency after foreclosure</option>
            <option value="mistake">Mistakenly listed as mortgage</option>
          </select>
          {declineReason && (
                <button
                    disabled={!declineReason || updatingType}
                    onClick={() => handleChangeAccountType(declineReason)}
                    className="mt-3 w-full bg-yellow-500 text-white font-medium py-2 rounded hover:bg-yellow-600 transition flex items-center justify-center gap-2 disabled:opacity-50"
                    >
                    {updatingType && <span className="inline-block h-4 w-4 border-2 border-t-transparent border-white rounded-full animate-spin" />}
                    Update Account
                    </button>
            )}
        </>
      )}

      <div className="flex justify-between items-center mt-4">
      <button
        disabled={!selectedAssetId || linking}
        onClick={handleLinkAsset}
        className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700 disabled:opacity-50 flex items-center justify-center gap-2"
        >
        {linking && <span className="inline-block h-4 w-4 border-2 border-t-transparent border-white rounded-full animate-spin"></span>} Link Asset
        </button>


        <button
          onClick={() => {
            setShowLinkAssetModal(false);
            setSelectedCreditor(null);
            setSelectedAssetId("");
            setDeclineReason("");
          }}
          className="text-sm text-gray-500 hover:text-gray-800"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
)}
        </div>
        </div>
      )}
    </div>
  );
}
